import Column from '../../components/Column';
import Row from '../../components/Row';
import usePageTitle from '../../hooks/usePageTitle';

import AccessDenyCallout from './AccessDenyCallout';

const AccessDeniedPage = () => {
    // build & render title
    usePageTitle({ segments: ['Access Denied'] });

    return (
        <Column gap={0} flex={1}>
            <Row width="100%" justifyContent="center" sx={{ p: 9 }}>
                <AccessDenyCallout />
            </Row>
        </Column>
    );
};

export default AccessDeniedPage;
